import { useState, useEffect } from 'react';
import { useAuthCliente } from '../context/AuthClienteContext';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

export function useMembers() {
  const { currentUser } = useAuthCliente();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (!currentUser?.companyId) return;

    const ref = collection(db, 'companies', currentUser.companyId, 'end_customers');
    const q = query(ref);

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        display: doc.data().name, // 'display' es requerido por react-mentions
        ...doc.data(),
      }));
      setMembers(data);
    });

    return () => unsubscribe();
  }, [currentUser?.companyId]);

  return { members };
}